import { render, staticRenderFns } from "./UserOption.vue?vue&type=template&id=498a59fc"
import script from "./UserOption.vue?vue&type=script&lang=js"
export * from "./UserOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports